var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcReading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1076",
    "data-name": "Rectangle 1076",
    width: 38,
    height: 38,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_reading",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(335.333 221.921)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1069",
    "data-name": "Rectangle 1069",
    width: 12.859,
    height: 23.928,
    transform: "translate(3.654 12.827) rotate(-45)",
    fill: "#54a847"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1070",
    "data-name": "Rectangle 1070",
    width: 7.042,
    height: 23.926,
    transform: "translate(7.769 8.715) rotate(-45.005)",
    fill: "#e08c35"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1071",
    "data-name": "Rectangle 1071",
    width: 1.509,
    height: 23.926,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 3.671, 12.813)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1072",
    "data-name": "Rectangle 1072",
    width: 1.51,
    height: 23.925,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 7.707, 8.777)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1073",
    "data-name": "Rectangle 1073",
    width: 1.511,
    height: 23.929,
    transform: "translate(11.746 4.735) rotate(-45)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21816",
    "data-name": "Path 21816",
    d: "M7.684,15.875l11.189,3-3-11.189Z",
    transform: "translate(16.416 16.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204-2",
    "data-name": "Group 204",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21817",
    "data-name": "Path 21817",
    d: "M19.384,20.139a.8.8,0,0,1-.2-.025L8,17.116a.759.759,0,0,1-.339-1.264l8.191-8.188A.754.754,0,0,1,17.113,8l3,11.189a.755.755,0,0,1-.727.951M9.655,15.995l8.66,2.32-2.32-8.66Z",
    transform: "translate(16.405 16.404)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1074",
    "data-name": "Rectangle 1074",
    width: 12.967,
    height: 2.283,
    transform: "translate(0.731 9.899) rotate(-45)",
    fill: "#d84f45"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1075",
    "data-name": "Rectangle 1075",
    width: 1.511,
    height: 2.366,
    transform: "translate(35.254 36.321) rotate(-45)",
    fill: "#404040"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReading);
export default __webpack_public_path__ + "static/media/ic_reading.9c9bd37dda688c39c9ba5678fe85d5ec.svg";
export { ForwardRef as ReactComponent };